/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { v4 as uuid } from 'uuid'
import { ConfigService } from '../services/configuration/config.service'

export const XTRACE_ID_PREFIX = 'XTRACE_ID_PREFIX'

@Injectable()
export class XTraceInterceptor implements HttpInterceptor {
  private traceIdPrefix = inject<string>(XTRACE_ID_PREFIX as any)
  private configService = inject(ConfigService)

  /**
   * Adds xtrace id to headers of request.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestClone = request.clone({
      setHeaders: {
        'X-TRACE-ID': `${this.traceIdPrefix}-${uuid()}`,
      },
    })
    return next.handle(requestClone)
  }
}
